import { makeNumberSchema, makeStrictNumberSchema } from '../general/number.ts';

const MIN = 500;
const MAX = 65_535;

const minMessage = `TX Queue must be at least ${MIN.toLocaleString()}`;
const maxMessage = `TX Queue can be at most ${MAX.toLocaleString()}`;
const requiredMessage = `Choose a number from ${MIN.toLocaleString()} to ${MAX.toLocaleString()}`;

export const tunTxQueueSchema = makeNumberSchema({
  min: { value: MIN, message: minMessage },
  max: { value: MAX, message: maxMessage },
});

export const tunTxQueueRequiredSchema = tunTxQueueSchema.refine((val): val is number => val !== null, {
  message: requiredMessage,
});

export const tunTxQueueStrictSchema = makeStrictNumberSchema({
  min: { value: MIN, message: minMessage },
  max: { value: MAX, message: maxMessage },
  required: { message: requiredMessage },
});
